"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tokens_1 = require("../tokens");
const error_1 = require("../error");
const tokens_2 = require("../tokens");
exports.NumberClass = {
    '+': (param, obj) => {
        const availableType = [tokens_1.LiteralTokens.NumberLiteral, tokens_1.LiteralTokens.StringLiteral];
        if (!availableType.includes(param.name)) {
            throw new error_1.TypeError(param.name);
        }
        if (!availableType.includes(obj.name)) {
            throw new error_1.TypeError(obj.name);
        }
        if (param.name === tokens_1.LiteralTokens.NumberLiteral && obj.name === tokens_1.LiteralTokens.NumberLiteral) {
            return {
                name: tokens_1.LiteralTokens.NumberLiteral,
                image: obj.image + param.image,
            };
        }
        else if (param.name === tokens_1.LiteralTokens.StringLiteral ||
            obj.name === tokens_1.LiteralTokens.StringLiteral) {
            return {
                name: tokens_1.LiteralTokens.StringLiteral,
                image: String(obj.image + param.image),
            };
        }
    },
    '-': (param, obj) => {
        const availableType = [tokens_1.LiteralTokens.NumberLiteral];
        if (!availableType.includes(param.name)) {
            throw new error_1.TypeError(param.name);
        }
        if (!availableType.includes(obj.name)) {
            throw new error_1.TypeError(obj.name);
        }
        return {
            name: tokens_1.LiteralTokens.NumberLiteral,
            image: obj.image - param.image,
        };
    },
    '*': (param, obj) => {
        const availableType = [tokens_1.LiteralTokens.NumberLiteral];
        if (!availableType.includes(param.name)) {
            throw new error_1.TypeError(param.name);
        }
        if (!availableType.includes(obj.name)) {
            throw new error_1.TypeError(obj.name);
        }
        return {
            name: tokens_1.LiteralTokens.NumberLiteral,
            image: obj.image * param.image,
        };
    },
    '/': (param, obj) => {
        const availableType = [tokens_1.LiteralTokens.NumberLiteral];
        if (!availableType.includes(param.name)) {
            throw new error_1.TypeError(param.name);
        }
        if (!availableType.includes(obj.name)) {
            throw new error_1.TypeError(obj.name);
        }
        return {
            name: tokens_1.LiteralTokens.NumberLiteral,
            image: obj.image / param.image,
        };
    },
    '%': (param, obj) => {
        const availableType = [tokens_1.LiteralTokens.NumberLiteral];
        if (!availableType.includes(param.name)) {
            throw new error_1.TypeError(param.name);
        }
        if (!availableType.includes(obj.name)) {
            throw new error_1.TypeError(obj.name);
        }
        return {
            name: tokens_1.LiteralTokens.NumberLiteral,
            image: obj.image % param.image,
        };
    },
    '<': (param, obj) => {
        return {
            name: tokens_1.LiteralTokens.BooleanLiteral,
            image: String(obj.image < param.image),
        };
    },
    '<=': (param, obj) => {
        return {
            name: tokens_1.LiteralTokens.BooleanLiteral,
            image: String(obj.image <= param.image),
        };
    },
    '>': (param, obj) => {
        return {
            name: tokens_1.LiteralTokens.BooleanLiteral,
            image: String(obj.image > param.image),
        };
    },
    '>=': (param, obj) => {
        return {
            name: tokens_1.LiteralTokens.BooleanLiteral,
            image: String(obj.image >= param.image),
        };
    },
    '~': (param, obj) => {
        return {
            name: tokens_1.LiteralTokens.NumberLiteralRange,
            start: obj.image,
            end: param.image,
        };
    },
    '=': (param, obj) => {
        if (param.name !== tokens_1.LiteralTokens.NumberLiteral) {
            return {
                name: tokens_1.LiteralTokens.BooleanLiteral,
                image: tokens_2.BooleanLiteralTokens.false,
            };
        }
        return {
            name: tokens_1.LiteralTokens.BooleanLiteral,
            image: String(param.image == obj.image),
        };
    },
};
